import { ALWAYS_INCLUDED_BENEFIT_TYPES } from "./constants";

export function loyaltyBenefitRuleFactory(currentTierId, loyaltySdk) {
  return async function loyaltyBenefitRule(node) {
    const { loyaltyBenefitType } = node;

    if (
      !loyaltyBenefitType ||
      ALWAYS_INCLUDED_BENEFIT_TYPES.includes(loyaltyBenefitType)
    ) {
      return true;
    }

    if (!loyaltySdk || !currentTierId) {
      return false;
    }

    const isBenefitAvailable = loyaltySdk.isBenefitAvailableForTier(
      currentTierId,
      loyaltyBenefitType
    );

    return isBenefitAvailable;
  };
}
